// extracted by mini-css-extract-plugin
export default {"foot":"foot__Y5cyD","mainWrp":"mainWrp__2LhW5","socials":"socials__Eqbju"};